import { createDZAxiosInstance } from '@dz-web/axios';
import { createBasicPatternMiddleware } from '@dz-web/axios-middlewares';
import axios from 'axios';

import StaticConfig from '@/helpers/static-config';
import { getPlatformIndependentUserConfig } from '@/utils/platfom-indepent/user-config';

import { IJavaBaseResponse } from '../types';

const isBusinessError = (data: IJavaBaseResponse) => data.code !== 0;

/**
 * 不需要登录的请求使用这个axios实例
 */
export const mobileShopInst = createDZAxiosInstance(
  () =>
    axios.create({
      baseURL: StaticConfig.getMobileShopServer(),
    }),
  [
    createBasicPatternMiddleware({
      addHeaders: () => {
        const { language } = getPlatformIndependentUserConfig();
        return {
          'Accept-Language': language,
        };
      },
      isBusinessError,
    }),
  ],
);
